/*=========================================================================================
  File Name: moduleAuthState.js
  Description: Auth Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import auth from '@/auth/service.js';

let state = {};

state.rawData = [];
state.topContactByAge = {
  '9': {},
  '10': {},
  '11': {},
  '12': {},
  '13': {},
  '14': {},
  '15': {},
  '16': {},
  '17': {}
};

export default state;
